/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiCampaignLeadStatus;
(function (ApiCampaignLeadStatus) {
    ApiCampaignLeadStatus["UNSPECIFIED"] = "CampaignLeadStatus_Unspecified";
    ApiCampaignLeadStatus["VARIANT"] = "CampaignLeadStatus_Variant";
    ApiCampaignLeadStatus["CONTROL"] = "CampaignLeadStatus_Control";
})(ApiCampaignLeadStatus || (ApiCampaignLeadStatus = {}));
export function ApiCampaignLeadStatusFromJSON(json) {
    return ApiCampaignLeadStatusFromJSONTyped(json, false);
}
export function ApiCampaignLeadStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiCampaignLeadStatusToJSON(value) {
    return value;
}
